<template>
  <el-input-number
    v-model="inputNum"
    size="small"
    :min="min"
    :max="max"
    @change="changeNum"
  />
</template>

<script>
export default {
  name: 'VInputNumber',
  props: {
    value: {
      type: [Number, String],
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      inputNum: this.value
    }
  },
  watch: {
    value(val) {
      this.inputNum = val
    }
  },
  methods: {
    changeNum(num) {
      this.$emit('input', num)
      this.$emit('change', num)
    }
  }
}
</script>